import { RootState } from '@store/index'
import { ResortDetails } from '@models/reservation'

export const selectResortDetails = (state: RootState): ResortDetails | undefined =>
  state.reservationsState.resortDetails
